export default "__VITE_ASSET__b2de9761__"